import { expensesApi } from '../api/expensesApi'
import type { ExpenseCategoryData } from '../schema/expensesSchema'

export const updateCategory = async (category: ExpenseCategoryData) => {
  try {
    const { data } = await expensesApi.updateCategory(category)
    return data
  } catch (error) {
    console.error(`Error updating category: `, error)
    throw error
  }
}
